import React from 'react';
import PropTypes from 'prop-types';
import {Link, useHistory, useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Chip from "@material-ui/core/Chip";
import styles from './NewsWidget.scss';

const formatDate = (date, format) => {
  date = new Date(date);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
  let dateString = `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
  if (format && format == 'long') dateString = `${dateString} ${date.getHours()}:${date.getMinutes()}${(date.getMinutes() < 12) ? 'am' : 'pm'}`;
  return dateString;
}

const updateQueryStringParameter = (uri, key, value) => {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
  } else {
      return uri + separator + key + "=" + value;
  }
}

function ArticleCard(props) {
  const {article, display} = props;
  const newsFilterData = useSelector(state => state.newsTopics.data);
  const history = useHistory();
  const location = useLocation();
  const tagClick = (event, topic) => {
    event.preventDefault();
    history.push(`/news${updateQueryStringParameter(location.search, 'Topic', topic)}`);
  }
  return (
    <Card className={`mb-4 ${styles.card} ${styles[display]}`}>
      <CardActionArea className="h-100" component={Link} to={article.url}>
        <div className={styles.thumbnail} style={{backgroundImage: `url(${article.thumbnailUrl})`}}>
          {article.type.length > 0 && <div className={styles.articleType}>{newsFilterData['Type'].find((typeData) => typeData.type == article.type[0]).label}</div>}
        </div>
        <CardContent className={styles.cardContent}>
          <h2 className={styles.truncateHeadline} dangerouslySetInnerHTML={{__html:article.headline}} title={article.headline}></h2>
          <p className={`${styles.truncateBlurb} flex-grow-1 mb-3`} dangerouslySetInnerHTML={{__html:article.abstract}}></p>
          <div>
            <div className="d-flex flex-row">
              <div><Typography variant="body2" color="textSecondary" component="p">{article.author}</Typography></div>
              <div className={styles.dot}></div>
              <div><Typography className="text-right" variant="body2" color="textSecondary" component="p">{formatDate(article.datePublished, 'short')}</Typography></div>
            </div>
            <div>
              {article.topic.map((item) => {
                if (item !== '') {
                  let labelItem = newsFilterData['Topic'].find((typeData) => typeData.type === item);
                  return (labelItem) ? <Chip key={item} label={labelItem.label} onClick={(e) => tagClick(e, item)} clickable className="mt-2 mr-2" /> : null;
                }
              })}
            </div>
          </div>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

ArticleCard.propTypes = {
  article: PropTypes.object.isRequired,
  display: PropTypes.oneOf(['row', 'column']),
};

export default ArticleCard;
